import { useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useAppLayoutContext } from '@/app/layout2/AppLayout';
import { useStickyHeaderContext } from '@/components/raytd/sticky-header-context';

type StickyHeaderProps = {
    children: React.ReactNode;
    offsetTop?: number;
    className?: string;
}

const StickyHeader: React.FC<StickyHeaderProps> = ({ children, offsetTop = 120, className }) => {

    const headerRef = useRef<HTMLElement>(null);
    const sentinelRef = useRef<HTMLDivElement>(null);

    const { isHeaderFixed, setIsHeaderFixed } = useStickyHeaderContext();
    const { showSidebar } = useAppLayoutContext();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When intersection ratio is less than 1, element is partially hidden
                // console.debug('toolbar entry', entry.intersectionRatio, entry.isIntersecting);
                setIsHeaderFixed(!entry.isIntersecting);
            },
            {
                threshold: [0], // Observe when element is fully visible
                rootMargin: `-${offsetTop}px 0px 0px 0px` // Trigger slightly before element starts moving
                // rootMargin: `0px 0px 0px 0px`
            }
        );

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => observer.disconnect();
    }, [offsetTop, setIsHeaderFixed]);

    useEffect(() => {
        console.debug('isHeaderFixed', isHeaderFixed);
    }, [isHeaderFixed]);

    // useEffect(() => {
    //     const targetDiv = document.querySelector('[data-viewport-type="window"]');
    //     if (targetDiv) {
    //         targetDiv.className = isHeaderFixed ? 'header-fixed' : 'header-default';
    //     }
    // }, [isHeaderFixed]);

    // VirtualisedItemList adjust the header height to avoid layout shift; GListComponent adjust the margin-top to avoid layout shift
    return (
        <>
            {/* The sentinel's purpose is to be the trigger for the IntersectionObserver */}
            <div ref={sentinelRef} style={{  height: '1px' }} />
            <header
                ref={headerRef}
                className={cn(
                    "max-w-screen-2xl mx-auto transition-all duration-300 ease-in-out",
                    {
                        // Base styles for the default (non-sticky) state
                        "relative bg-white": !isHeaderFixed,
                        // Styles for the fixed (sticky) state
                        "sticky top-0 z-50": true,
                        // "border-b-2 border-zinc-200": isHeaderFixed,
                        // This conditional width might be better handled by a parent layout component
                        "w-full left-0": true && !showSidebar,
                        
                    },
                    className
                )}
            >
                <div className="flex items-center justify-between w-full flex-col bg-white">
                    <div className="w-full mx-auto h-full">
                        {children}
                    </div>

                </div>
            </header>
        </>
    );
};

export default StickyHeader;